import { createSelector } from 'reselect';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getAnalogLinks = createSelector(getActiveComponentDesign, (componentDesign) =>
  componentDesign?.analogModel
    ? Object.fromEntries(componentDesign.analogModel.analogLinks.map((link) => [link.guid, link]))
    : null,
);
